import { ReportData } from '../types/reportTypes';

// Cody Cline Direct Sales September 2025 Data
// IMPORTANT: Using 13% flat OH calculation (Contract Total × 0.13) retroactive to 1/1/2025
const jobData = [
  {
    jobInfo: "E-597: Thomas Rosenfield",
    leadSource: "Referral- Dominic's network",
    trade: "Siding",
    contractTotal: 14090.55,
    grossMarginPct: 0.5111,
    grossProfit: 7201.68,
    commissionPercentage: 0,
    salesCommission: 0, // Will be calculated
    salesManagerFee: 0,
    companyOH: 14090.55 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-627: Keyur & Alyson Desai",
    leadSource: "Referral - From past customer",
    trade: "Roofing",
    contractTotal: 19024.26,
    grossMarginPct: 0.4379,
    grossProfit: 8330.72,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 19024.26 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-619: Rachel Alexander",
    leadSource: "Referral- Dominic's network",
    trade: "Roofing",
    contractTotal: 10513.00,
    grossMarginPct: 0.3912,
    grossProfit: 4112.69,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 10513.00 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-616: Grant Fuller",
    leadSource: "Referral- Dominic's network",
    trade: "Roofing",
    contractTotal: 7085.00,
    grossMarginPct: 0.3443,
    grossProfit: 2439.37,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 7085.00 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-628: Nancy Toy",
    leadSource: "Referral- Dominic's network",
    trade: "Roofing",
    contractTotal: 12995.00,
    grossMarginPct: 0.5516,
    grossProfit: 7168.04,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 12995.00 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-622: Kingsgate A Condominium",
    leadSource: "Referral- Dominic's network",
    trade: "Windows & Doors",
    contractTotal: 2568.50,
    grossMarginPct: 0.6107,
    grossProfit: 1568.58,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 2568.50 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-624: Adam Pomeranz",
    leadSource: "Referral- Dominic's network",
    trade: "Roofing",
    contractTotal: 6800.00,
    grossMarginPct: 0.2808,
    grossProfit: 1909.44,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 6800.00 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-614: Jessica Crosby",
    leadSource: "Referral- Dominic's network",
    trade: "Roofing",
    contractTotal: 15899.00,
    grossMarginPct: 0.4813,
    grossProfit: 7652.19,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 15899.00 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-629: Amalia Safer",
    leadSource: "Referral- Dominic's network",
    trade: "Roofing",
    contractTotal: 6800.00,
    grossMarginPct: 0.4333,
    grossProfit: 2946.44,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 6800.00 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-607: Ellicott Hills Condo 1",
    leadSource: "Referral- Dominic's network",
    trade: "Painting & Others",
    contractTotal: 2285.50,
    grossMarginPct: 0.6937,
    grossProfit: 1585.45,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 2285.50 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-625: Julie Jones C/O",
    leadSource: "Referral- Cody's network",
    trade: "Windows & Doors",
    contractTotal: 1949.00,
    grossMarginPct: 0.4244,
    grossProfit: 827.16,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 1949.00 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-598: Chris Meckel Binkley-Chalk Project",
    leadSource: "Referral- Cody's network",
    trade: "Siding",
    contractTotal: 29212.05,
    grossMarginPct: 0.2373,
    grossProfit: 6932.02,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 29212.05 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-586: Kristin Savercool",
    leadSource: "Referral- Cody's network",
    trade: "Roofing",
    contractTotal: 21675.00,
    grossMarginPct: 0.4546,
    grossProfit: 9853.46,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 21675.00 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-592: John Tabor Wade Project",
    leadSource: "Referral- Cody's network",
    trade: "Siding",
    contractTotal: 3571.90,
    grossMarginPct: 0.3000,
    grossProfit: 1071.57,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 3571.90 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-587: Jordan  Gottlieb",
    leadSource: "Referral- Dominic's network",
    trade: "ROI Roofing",
    contractTotal: 1950.00,
    grossMarginPct: 0.4872,
    grossProfit: 950.04,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 1950.00 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-603: Santiago Abal",
    leadSource: "Referral- Dominic's network",
    trade: "ROI Siding",
    contractTotal: 1990.00,
    grossMarginPct: 0.6828,
    grossProfit: 1358.77,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 1990.00 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-595: Glenford Blanc",
    leadSource: "Referral- Dominic's network",
    trade: "Siding",
    contractTotal: 5729.00,
    grossMarginPct: 0.3000,
    grossProfit: 1718.70,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 5729.00 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-589: William Dick",
    leadSource: "Referral- Cody's network",
    trade: "Solar Install",
    contractTotal: 16183.64,
    grossMarginPct: 0.4516,
    grossProfit: 7308.53,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 16183.64 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-631: Pennrose Management Oak Liberty Property",
    leadSource: "Referral- Cody's network",
    trade: "Roofing",
    contractTotal: 2298.50,
    grossMarginPct: 0.7390,
    grossProfit: 1698.59,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 2298.50 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-615: Tai Mai",
    leadSource: "Referral- Dominic's network",
    trade: "Roofing",
    contractTotal: 14517.00,
    grossMarginPct: 0.5112,
    grossProfit: 7421.09,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 14517.00 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-591: Pennrose Management",
    leadSource: "Referral- Cody's network",
    trade: "Roofing",
    contractTotal: 6869.58,
    grossMarginPct: 0.4570,
    grossProfit: 3139.40,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 6869.58 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "S-3120: Willa Morris",
    leadSource: "Site Survey Website",
    trade: "Solar Install",
    contractTotal: 41701.00,
    grossMarginPct: 0.3000,
    grossProfit: 12510.30,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 41701.00 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-608: The Enclave at Ellicott Hills",
    leadSource: "Referral- Dominic's network",
    trade: "Solar Install",
    contractTotal: 599.00,
    grossMarginPct: 0.4633,
    grossProfit: 277.52,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 599.00 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "S-3138: Helen Woldeab",
    leadSource: "Site Survey Website",
    trade: "Solar Install",
    contractTotal: 48999.00,
    grossMarginPct: 0.3000,
    grossProfit: 14699.70,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 48999.00 * 0.13, // 13% flat rate
    netProfit: 0
  }
];

// Apply Cody Cline calculation formula
// For Cody reports: Net Profit = Gross Profit - Company OH
// Sales Commission = Net Profit ÷ 2 (50% of Net Profit)
jobData.forEach(job => {
  job.netProfit = job.grossProfit - job.companyOH;
  job.salesCommission = job.netProfit / 2;
});

// Calculate totals
const totalContractValue = jobData.reduce((sum, job) => sum + job.contractTotal, 0);
const totalGrossProfit = jobData.reduce((sum, job) => sum + job.grossProfit, 0);
const totalCompanyOH = jobData.reduce((sum, job) => sum + job.companyOH, 0);
const totalNetProfit = jobData.reduce((sum, job) => sum + job.netProfit, 0);
const totalSalesCommissions = jobData.reduce((sum, job) => sum + job.salesCommission, 0);

// Aggregate sales by source
const salesBySourceMap = jobData.reduce((acc, job) => {
  const source = job.leadSource;
  if (!acc[source]) {
    acc[source] = {
      source,
      totalSales: 0,
      count: 0,
      grossProfit: 0
    };
  }
  acc[source].totalSales += job.contractTotal;
  acc[source].count += 1;
  acc[source].grossProfit += job.grossProfit;
  return acc;
}, {} as Record<string, { source: string; totalSales: number; count: number; grossProfit: number }>);

const salesBySource = Object.values(salesBySourceMap);

// Aggregate sales by trade
const salesByTradeMap = jobData.reduce((acc, job) => {
  const trade = job.trade;
  if (!acc[trade]) {
    acc[trade] = {
      trade,
      totalSales: 0,
      count: 0,
      grossProfit: 0
    };
  }
  acc[trade].totalSales += job.contractTotal;
  acc[trade].count += 1;
  acc[trade].grossProfit += job.grossProfit;
  return acc;
}, {} as Record<string, { trade: string; totalSales: number; count: number; grossProfit: number }>);

const salesByTrade = Object.values(salesByTradeMap);

export const codySalesSeptemberData: ReportData = {
  kpis: {
    adSpend: 0, // No ad spend for Cody direct sales
    totalSales: totalContractValue,
    grossProfit: totalGrossProfit,
    salesCommissions: totalSalesCommissions,
    managerFees: 0, // No manager fees in Cody structure
    companyOH: totalCompanyOH,
    netProfit: totalNetProfit,
    netProfitPercent: totalNetProfit / totalContractValue,
    grossProfitPercent: totalGrossProfit / totalContractValue
  },

  adSpendBySource: [
    { source: "Referral- Cody's network", spend: 0 },
    { source: "Referral- Dominic's network", spend: 0 },
    { source: "Referral - From past customer", spend: 0 },
    { source: "Site Survey Website", spend: 0 }
  ],

  salesBySource: salesBySource,

  salesByTrade: salesByTrade,

  jobData: jobData,

  period: {
    month: 9,
    year: 2025
  }
};
